import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { v4 as uuid } from "uuid";
import Input from "@material-ui/core/Input";
import Button2 from "@material-ui/core/Button";
import { useFormik } from "formik";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import * as Yup from "yup";
import axios from "axios";
import Preview from "../components/Preview.js";
import InputMask from "react-input-mask";


const initialValues = {
  name: "",
  contactPerson: "",
  phoneNumber: "",
  email: "",
  filePath: "",
  barcodePrefix: ""
};

export default function Create(props) {
  const { show, onHide, onAssets, skip, take, sortField, orderBy } = props;
  const [imageSrc, setImageSrc] = useState("");
  const [preview, setPreview] = useState(false);
  const [file, setFile] = useState("");
  const [isError, setIsError] = useState("");

  const form = useRef(null);

  const [phoneNumber, setPhoneNumber] = React.useState("");
  // function handleChangePhoneNumber(e) {
  //   setPhoneNumber(e.target.value);
  // }


  const CreateSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    contactPerson: Yup.string().required("Contact person is required"),
    phoneNumber: Yup.string().required("Phone number is required"),
    email: Yup.string().required("Email is required")
    .email("Wrong email format. E.g. jhon.doe@example.com")
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    ,
    barcodePrefix: Yup.string().required("Barcode is required")
      .max(3, 'Barcode must consist of max 3 letter'),
    // filePath: Yup.string().required("FilePath is required"),
  });

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const imagePreview = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    setFile(e.target.value);

    reader.onloadend = () => {
      setImageSrc(reader.result);
    };

    reader.readAsDataURL(file);

    setPreview(true);
  };
  const onClick = (e) => {
    setPreview(false);
    setImageSrc("");
    setFile("");
  };

  const onPostAsset = (values, resetForm, setSubmitting) => {
    const asset = new FormData(form.current);
    axios
      .post(`${process.env.REACT_APP_API_URL}asset`, asset, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onAssets(skip, take, sortField, orderBy);
        setPreview(false);
        setImageSrc("");
        setFile("");
        setSubmitting(false);
        resetForm();
        onHide();
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostAsset(values, resetForm, setSubmitting);
    },
  });

  useEffect(() => {
    setIsError("");
    setPhoneNumber("");

  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="edit"
      centered
      className="modal-right pr-0"
    >
      <form onSubmit={formik.handleSubmit} ref={form}>
        <Modal.Header closeButton>
          <Modal.Title id="edit">Create</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="name"
                    name="name"
                    label="Name"
                    placeholder="Name"
                    className="w-100"
                    error={getInputClasses("name")}
                    {...formik.getFieldProps("name")}
                  />
                </div>
                {formik.touched.name && formik.errors.name ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.name}</div>
                  </div>
                ) : null}
              </div>

              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="contactPerson"
                    name="contactPerson"
                    label="Contact person"
                    placeholder="Contact person"
                    className="w-100"
                    error={getInputClasses("contactPerson")}
                    {...formik.getFieldProps("contactPerson")}
                  />
                </div>
                {formik.touched.contactPerson && formik.errors.contactPerson ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.contactPerson}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  {/* <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="phoneNumber"
                    name="phoneNumber"
                    label="Phone Number"
                    placeholder="Phone Number"
                    className="w-100"
                    error={getInputClasses("phoneNumber")}
                    {...formik.getFieldProps("phoneNumber")}
                  /> */}
                  <InputMask
                    mask="\9\94999999999"
                    {...formik.getFieldProps("phoneNumber")}
                    disabled={false}
                    maskChar=""
                    id="phoneNumber"
                    type="number"
                  >
                    {() =>
                      <TextField
                        label="Phone Number"
                        placeholder="Phone Number"
                        className="w-100"
                        name="phoneNumber"
                      // error={getInputClasses("cityPhoneNumber")}
                      />}
                  </InputMask>
              </div>
              {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.phoneNumber}
                  </div>
                </div>
              ) : null} 
               </div>

               <div className="d-none">{phoneNumber}</div>


              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="email"
                    name="email"
                    label="Contact person email"
                    placeholder="Contact person email"
                    className="w-100"
                    error={getInputClasses("email")}
                    {...formik.getFieldProps("email")}
                  />
                </div>
                {formik.touched.email && formik.errors.email ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.email}</div>
                  </div>
                ) : null}
              </div>

              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3">
                  <label htmlFor="contained-button-file">
                    <Input
                      accept="image/*"
                      id="contained-button-file"
                      type="file"
                      name="file"
                      label="File {Path}"
                      placeholder="File Path"
                      className="w-100"
                      onChange={imagePreview}
                      value={file}
                      hidden
                    />
                    <Button2 variant="contained" component="span">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Devices/Camera.svg"
                        )}
                        className="mr-2"
                      />
                      Upload image
                    </Button2>
                  </label>
                  <Preview
                    preview={preview}
                    imageSrc={imageSrc}
                    onClick={onClick}
                  />
                </div>
                {formik.touched.filePath && formik.errors.filePath ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.filePath}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="barcodePrefix"
                    name="barcodePrefix"
                    label="Barcode "
                    placeholder="Barcode"
                    className="w-100"
                    error={getInputClasses("barcodePrefix")}
                    {...formik.getFieldProps("barcodePrefix")}
                  />
                </div>
                {formik.touched.barcodePrefix && formik.errors.barcodePrefix ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.barcodePrefix}</div>
                  </div>
                ) : null}


                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => onHide(false)}>
            Close
          </Button>
          <Button type="submit">Create</Button>
        </Modal.Footer>
      </form>
    </Modal >
  );
}
